import { render, staticRenderFns } from "./PreviewHeader.vue?vue&type=template&id=3fb49a43&"
import script from "./PreviewHeader.vue?vue&type=script&lang=js&"
export * from "./PreviewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports